import { usePage } from "@inertiajs/vue3";
import type { UserDetails } from "~vue/appTypes";
import { computed } from "vue";

export function useProfileSharingCopy() {
    const page = usePage<{ pair_perspective_enabled?: boolean; user_details?: UserDetails | null }>();
    const canComparePerspectives = computed(() => page.props.pair_perspective_enabled === true);
    const teamsEnabled = computed(() => page.props.user_details?.is_teams_enabled === true);
    const sharingDisclosure = "Sharing your Collaboration Profile includes your Perspective results when available.";

    return { canComparePerspectives, sharingDisclosure, teamsEnabled };
}
